module.exports = __webpack_public_path__ + "static/media/link-solid.ca731133.svg";